/**
 * Tenant slug registry (issue #7).
 *
 * Replaces standalone-search's cosmetic preset registry (peach/tangerine/…).
 * "Preset" == tenant slug here — theming is tenant-driven, never user-choice.
 * The `data-theme-preset` attribute is set once at boot from the subdomain
 * and never changes within a session. No localStorage persistence.
 *
 * The Murtada preset uses its supplied deep green as the institutional frame
 * and lapis for interactive state, so brand and action remain distinct.
 * Mufid retains its own tenant preset without inheriting Murtada's brand colors.
 */

export const TENANT_SLUGS = ["murtada", "mufid"] as const;
export type TenantSlug = (typeof TENANT_SLUGS)[number];

const TENANT_SLUG_SET = new Set<string>(TENANT_SLUGS);

/**
 * Validate an arbitrary string against the known tenant slugs.
 * Unknown values return null so no tenant theme is selected.
 */
export function resolveTenantTheme(value: unknown): TenantSlug | null {
  if (typeof value === "string" && TENANT_SLUG_SET.has(value)) {
    return value as TenantSlug;
  }
  return null;
}
